import { Box, Container, Paper } from '@mui/material'
import { ReactNode } from 'react'
import { PLATFORM_BACKGROUND_URL, PLATFORM_LOGO_URL } from './platformAssets'

// Shared chrome for every public /signup screen: the full-bleed login background, a centered card, and
// the LogikSpark logo above the content. The signup form and the result screens (check-email / expired /
// invalid-link) all render through this so the flow is visually consistent.
const SignupLayout = ({ children }: { children: ReactNode }) => (
  <Box
    sx={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      backgroundImage: `url(${PLATFORM_BACKGROUND_URL})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
    }}
  >
    <Container maxWidth='sm' sx={{ py: 6 }}>
      <Paper sx={{ p: 4 }}>
        <Box
          component='img'
          src={PLATFORM_LOGO_URL}
          alt='LogikSpark'
          sx={{ display: 'block', width: '100%', maxWidth: 260, height: 'auto', mx: 'auto', mb: 3 }}
        />
        {children}
      </Paper>
    </Container>
  </Box>
)

export default SignupLayout
